import {TabPanel, TabView} from 'primereact/tabview';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
import BaseContainer from '../baseContainers/BaseContainer';
import {CustomMessages} from '../components/CustomMessages';
import BlockUi from '../components/waitPanel/BlockUi';
import AccountService from '../services/AccountService';
import InvoiceListContainer from './InvoiceListContainer';
import TransactionListContainer from './TransactionListContainer';
import OrderListContainer from './OrderListContainer';

class BalanceCashlessContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.accountService = new AccountService();
        this.state = {
            activeIndex: 0,
            inProgressCount: 0,
            draftsCount: 0,
            loading: true,
            balance: {
                creditLimit: undefined,
                unInvoicedOrdersCount: 0,
                unpaidInvoicesCount: 0,
            },
        };
        this.handleTabChange = this.handleTabChange.bind(this);
        this.initializeFromBackend = this.initializeFromBackend.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        this.initializeFromBackend();
    }
    initializeFromBackend() {
        const {t} = this.props;
        let activeIndex = this.readCookie(`balance-cashless-list-activeIndex`);
        if (activeIndex === undefined || activeIndex === null || activeIndex === '') {
            activeIndex = 0;
        }
        this.accountService
            .getBalance(true)
            .then((balance) => {
                this.setState({balance, loading: false, activeIndex: parseInt(activeIndex)}, () => {
                    this.unblockUi();
                });
            })
            .catch(() => {
                this.setState({loading: false, activeIndex: parseInt(activeIndex)}, () => {
                    this.unblockUi();
                });
                this.showErrorMessage(t('error.getBalanceError'));
            });
    }
    getContainerListName() {
        return 'balance-cashless-container';
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    handleTabChange(e) {
        this.setState(
            {
                activeIndex: e.index,
            },
            () => {
                this.saveCookie(`balance-cashless-list-activeIndex`, this.state.activeIndex);
            }
        );
    }
    readCookie(cookieName) {
        return sessionStorage.getItem(cookieName);
    }
    saveCookie(cookieName, cookieValue) {
        sessionStorage.setItem(cookieName, cookieValue);
    }
    render() {
        return (
            <React.Fragment>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    {this.renderView()}
                </BlockUi>
            </React.Fragment>
        );
    }
    renderView() {
        const {t} = this.props;
        const fieldsList = ['creditLimit', 'remainingLimit'];
        const isWholesale =
            this.authService.getProfile().agreementSapRole === 'HURT' ||
            this.authService.getProfile().agreementSapRole === 'FRANCZYZA' ||
            this.authService.getProfile().agreementSapRole === 'HURT EPT';
        const isCashless =
            this.authService.getProfile().agreementSapRole === 'FLOTA' && this.authService.getProfile().agreementType === 'CASHLESS';
        if (isWholesale) {
            fieldsList.push('uninvoicedOrders');
        } else {
            fieldsList.push('uninvoicedTransactions');
        }
        fieldsList.push('unpaidSettlement');
        if (isWholesale || isCashless) {
            fieldsList.push('unclearedIncomes');
        }
        return (
            <div className='balance-details-site'>
                <div className='header-content'>
                    <span className='header-welcome header-welcome-label'>{t('balance.detailsHeader')}</span>
                </div>

                <div className='balance-details-header'>
                    <div className='row balance-details-row'>
                        {fieldsList.map((field) => {
                            return (
                                <div className={`col-lg-3 col-md-6`} key={`balance-div-${field}`}>
                                    <div className='balance-value'>
                                        <div className='balance-input-header'>
                                            <span className='label'>{t(`balance.${field}`)}</span>
                                            <span className={`value ${field === 'remainingLimit' ? 'bold' : ''}`}>
                                                <NumberFormat
                                                    key={`balance-${field}`}
                                                    value={!!this.state.balance[`${field}`] ? this.state.balance[`${field}`] : 0}
                                                    className='value'
                                                    displayType={'text'}
                                                    thousandSeparator=' '
                                                    decimalSeparator=','
                                                    fixedDecimalScale
                                                    decimalScale={2}
                                                    suffix={` ${t('currency.pln')}`}
                                                    renderText={(value, props) => value}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className='container-fluid'>
                    <TabView activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange}>
                        <TabPanel
                            header={`${t(
                                isWholesale ? 'balance.uninvoicedOrdersTabHeaderTitle' : 'balance.uninvoicedTransactionsTabHeaderTitle'
                            )} (${isWholesale ? this.state.ordersCount ?? 0 : this.state.balance.unInvoicedOrdersCount})`}
                        >
                            <React.Fragment>
                                {isWholesale ? (
                                    <OrderListContainer
                                        hideFilters
                                        uninvoiced
                                        blockUi={this.blockUi}
                                        unblockUi={this.unblockUi}
                                        showMessage={this.showMessage}
                                        embedded
                                        _isMounted={this._isMounted}
                                        onAfterGetList={(data) =>
                                            this.setState({ordersCount: data.ordersCount, draftsCount: data.draftsCount}, this.unblockUi())
                                        }
                                        afterGetListError={this.unblockUi}
                                    />
                                ) : (
                                    this.authService.getProfile().agreementSapRole === 'FLOTA' && this.isUserHasAnyPermission('PERMISSION_VIEW_TRANSACTIONS', 'PERMISSION_EDIT_TRANSACTIONS') && (
                                        <TransactionListContainer
                                            hideFilters
                                            unInvoiced
                                            blockUi={this.blockUi}
                                            unblockUi={this.unblockUi}
                                            showMessage={this.showMessage}
                                            _isMounted={this._isMounted}
                                            embedded
                                        />
                                    )
                                )}
                            </React.Fragment>
                        </TabPanel>
                        <TabPanel header={`${t('balance.unpaidSettlementTabHeaderTitle')} (${this.state.balance.unpaidInvoicesCount})`}>
                            {(isWholesale || (this.authService.getProfile().agreementSapRole === 'FLOTA' && this.isUserHasAnyPermission('PERMISSION_VIEW_INVOICES', 'PERMISSION_EDIT_INVOICES'))) && (
                                <React.Fragment>
                                    <InvoiceListContainer
                                        hidePaymentDetails
                                        hideFilters
                                        statusSc={{enumValue: 'UNPAID'}}
                                        blockUi={this.blockUi}
                                        unblockUi={this.unblockUi}
                                        showMessage={this.showMessage}
                                        embedded
                                        _isMounted={this._isMounted}
                                    />
                                </React.Fragment>
                            )}
                        </TabPanel>
                    </TabView>
                </div>
            </div>
        );
    }
}
BalanceCashlessContainer.defaultProps = {
    viewMode: 'VIEW',
};

BalanceCashlessContainer.propTypes = {
    newUrl: PropTypes.string,
    viewMode: PropTypes.string,
};

export default withTranslation()(BalanceCashlessContainer);
